import axios from 'axios'
import store from '@/store'
import Repository from '../repositories/repositoryFactory';
import Vue from "vue";
import * as moment from 'moment/moment';
const AuthRepository = Repository.get('auth');


export default {

  setConfig() {
    return new Promise((resolve, reject) => {
      if (helper.getConfig('loaded')) {
        resolve()
      } else {
        AuthRepository.getConfig()
          .then(response => {
            let resp = response.data;
            store.dispatch('resetConfig');
            resp.loaded = true;
            store.dispatch('setConfig', resp);
            resolve();
          }).catch(error => {
          reject(error);
        })
          .catch(error => {
            reject(error)
          })
      }
    })
  },

  // to append filter variables in the URL
  getFilterURL(data) {
    let url = '';
    $.each(data, function (key, value) {
      url += (value) ? '&' + key + '=' + encodeURI(value) : '';
    });
    return url;
  },

  // to change first character of every word to upper case
  ucword(value) {
    if (!value)
      return;

    return value.toLowerCase().replace(/\b[a-z]/g, function (value) {
      return value.toUpperCase();
    });
  },

  // to change string into human readable format
  toWord(value) {
    if (!value)
      return;

    value = value.replace(/-/g, ' ');
    value = value.replace(/_/g, ' ');

    return value.toLowerCase().replace(/\b[a-z]/g, function (value) {
      return value.toUpperCase();
    });
  },

  createSlug(value) {
    return value.toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with
      .replace(/&/g, '-and-') // Replace & with ‘and’
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple — with single -
      .replace(/^-+/, '') // Trim — from start of text .replace(/-+$/, '');
  },

  // shows notification for axios form request
  showErrorMsg(error) {
    if (error.hasOwnProperty("response")) {
      const statusCode = error.response.status;

      const message = error.response.hasOwnProperty("data") ? error.response.data.message : error.response.message;
      const login = error.response.hasOwnProperty("data") ? error.response.data.login : error.response.login;

      console.log("login :: ",login);

      if (statusCode == 400 || statusCode == 401 || statusCode == 403) {
        UIkit.notification(message, {status: 'danger'});
      } else if (statusCode == 500) {
        UIkit.notification('Something went wrong', {status: 'danger'});
      } else if (statusCode == 422 && error.response.hasOwnProperty("errors")) {
        UIkit.notification(error.response.errors, {status: 'danger'});
      } else if (statusCode == 422 && error.response.hasOwnProperty("data")) {
        UIkit.notification(error.response.data.errors.message[0], {status: 'danger'});
      } else if (statusCode == 404) {
        UIkit.notification('This is not a valid link.', {status: 'danger'});
      }

      if (login) {
        //this.clearSession();
        location.reload();
      }
    } else if (error.hasOwnProperty("errors") && error.errors.hasOwnProperty("message")) {
      const message = error.errors.hasOwnProperty("message") ? error.errors.message[0] : '';
      if (message) {
        UIkit.notification(message, {status: 'danger'});
      }
    }else{
      const statusCode = error.status;
      const message = error.errors;
      if (statusCode == 400 || statusCode == 401 || statusCode == 403) {
        UIkit.notification(error.errors, {status: 'danger'});
      } else if (statusCode == 500) {
        UIkit.notification(message, {status: 'danger'});
      } else if (statusCode == 422 && error.hasOwnProperty("errors")) {
        UIkit.notification(error.errors.user, {status: 'danger'});
      } else if (statusCode == 404) {
        UIkit.notification(message, {status: 'danger'});
      }
      else if (statusCode == 409) {
        UIkit.notification(message, {status: 'danger'});
      }
    }
  },

  // returns error message for axios form request
  fetchErrorMsg(error) {
    return error.errors.message[0];
  },

  // round numbers as given precision
  roundNumber(number, precision) {
    precision = Math.abs(parseInt(precision)) || 0;
    var multiplier = Math.pow(10, precision);
    return (Math.round(number * multiplier) / multiplier);
  },

  // round numbers as given precision
  formatNumber(number, decimal_place) {
    if (decimal_place === undefined)
      decimal_place = 2;
    return this.roundNumber(number, decimal_place);
  },

  /**
   * Capitalize first character of the target string.
   * @param  {string} string Target string
   * @returns {string} Converted new string
   */
  toUpperCaseFirstLetter: function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  },


  // fill number with padding
  formatWithPadding(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  },

  // generates random string of certain length
  randomString(length) {
    if (length === undefined)
      length = 40;
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  },

  bytesToSize(bytes) {
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes == 0) return '0 Byte';
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  },

  jsonStringArrayToStringWrap(array) {
    let arr = array.map(function (obj) {

      try {
       return JSON.parse(obj).name;
      } catch (e) {
          return '';
      }
      
    });
    return arr.join(', ')
  },

  arrayToStringWrap(array) {
    let arr = array.map(function (obj) {
      return obj.name || obj.text;
    });
    return arr.join(', ')
  },

  arrayOfArrayToStringWrap(array,key) {
    let arr = array.map(function (obj) {
      return obj[key]
    });
    arr = _.flatten(arr);
    arr = arr.map(function (obj) {
      return obj.name || obj.text;
    });
    arr = _.uniq(arr);
    return arr.join(', ')
  },

  arrayToJsonString(array) {
    return array.map(function (obj) {
      return JSON.stringify(obj);
    })
  },

  jsonStringToArray(array){
    return array.map(function (obj) {
      return JSON.parse(obj);
    })
  },

  jsonToString(obj) {
    return JSON.stringify(obj);
  },

  stringToJson(obj) {
    return JSON.parse(obj);
  },


  // to logout user
  logout() {
    let loader = Vue.$loading.show();
    return AuthRepository.logout().then(response => {
      this.clearSession();
      UIkit.notification(response.data.message, {status: 'success'});
      loader.hide();
    }, (error => {
      loader.hide();
    }))
  },

  //to validate reset password token
  checkResetToken(token) {
    return AuthRepository.resetTokenValidation({token : token});
  },

  //Authentication
  clearSession() {
    Vue.cookie.delete('auth_token');
    store.commit('resetAuthUserDetail');
    store.commit('resetNewPartner');
    store.commit('resetDashRoleId');
  },

  getNewToken() {

  },

  getUserName () {
    return this.$store.getters.getAuthUser;
  },
  getUserRole () {
    return this.$store.getters.getAuthUserRole;
  },

  fbLogin () {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: '545128646390179',
        cookie: true,                     // Enable cookies to allow the server to access the session.
        xfbml: true,                     // Parse social plugins on this webpage.
        version: 'v2.10'           // Use this Graph API version for this call.
      });
    }

    (function(d, s, id) {                      // Load the SDK asynchronously
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },

  hasAdminDashRole() {
    return store.state.dashRoleId === 41;
  },
  hasBdSalesDashRole() {
    return store.state.dashRoleId === 44;
  },
  hasPartnerDashRole() {
    return store.state.dashRoleId === 46;
  },
  hasSalesDashRole() {
    return store.state.dashRoleId === 47;
  },
  hasBdDashRole() {
    return store.state.dashRoleId === 42;
  },
  hasSeoDashRole() {
    return store.state.dashRoleId === 43;
  },
  hasAccountDashRole() {
    return store.state.dashRoleId === 48;
  },


  hasAdminRole() {
    return store.state.auth.role_id === 41;
  },

  hasOriginalAdmin() {
    return store.state.sauth.role_id === 41;
  },


  hasPartnerRole() {
    //console.log(store.state);
    return store.state.auth.role_id === 46 || store.state.dashRoleId == 46;
  },


  hasSalesRole () {
    return store.state.auth.role_id === 47 || store.state.dashRoleId == 47; 
  },

  hasOriginalSales () {
    return store.state.sauth.role_id === 47; 
  },



  hasbdSalesRole () {
    return store.state.auth.role_id === 42; 
  },

  hasOriginalBdSales () {
    return store.state.sauth.role_id === 42; 
  },


  hasbdRole () {
    return store.state.auth.role_id === 42; 
  },

  hasOriginalBd () {
    return store.state.sauth.role_id === 42; 
  },


  hasseoRole () {
    return store.state.auth.role_id === 43; 
  },

  hasaccountRole () {
    return store.state.auth.role_id === 48 || store.state.dashRoleId === 48; 
  },
  hasOriginalAccount () {
    return store.state.sauth.role_id === 48; 
  },
  hasPackageCopyPermission(statusId){
    if(this.hasPartnerRole()){
      return true;
    }
    return false;
  },
  isSendablePackage(statusId){
    if([7].includes(statusId)){
      return true;
    }
    return false;
  },
  //TODO:: check eith status id better make an api for edit permission
  hasPackageEditPermission(statusId) {
    //console.log(store.state.auth.role_id,'store.state.auth.role_id',store.state.dashRoleId)
    if(store.state.auth.role_id == 41 && store.state.dashRoleId == 41){
      return false;
    }
    if(store.state.auth.role_id == 41 && store.state.dashRoleId == 46){ //super admin give edit permision
      return true;
    }
    if((store.state.dashRoleId == 41 || store.state.dashRoleId == 42) && ![2,7].includes(statusId)){
      return true;
    }
    if([2,7].includes(statusId) && this.hasPartnerRole()){
      return false;
    }else {
      return true;
    }
  },

  // to get config
  getConfig(config) {
    return store.getters.getConfig(config);
  },

  hasPartnerApproved: function() {
    return helper.getConfig('is_approved');
  },

  getAuthStatus: function() {
    return store.state.auth.status;
  },

  setNewPartner: function () {
    store.dispatch('setNewPartner', true);
  },

  hasNewPartner: function () {
    return store.state.isNewPartner
  },

  //TODO:: check with status id
  hasApprovedStatus: function (id) {
    return parseInt(id+'') === 4;    //approved status id
  },
  hasApprovedPackage: function (id) {
    return parseInt(id+'') === 7;    //approved status id
  },

  hasCompletedStatus: function (id) {
    return parseInt(id+'') === 15;    //completed status id
  },

  hasRequestedStatus: function (id) {
    return parseInt(id+'') === 24;   //Requested status id
  },

  hasModificationStatus: function (id) {
    return parseInt(id+'') === 10;   //Modification Required status id
  },

  getDraftStatus: function () {
    return 8;               //Draft status
  },

  //New changes::
  getPartnerRequestedStatus: function () {
    return 13;
  },

  getMonths () {
    return ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  },


 /* getSalesUrl () {
      if(helper.hasSalesRole() == true){
        return ["/enquiry", "/qa", "/bookings", "/packages", "/properties", "/partners",
          "/staff", "/support"
        ];
      }else if(helper.hasAdminRole() == true){
        return ["/dashboard","/enquiry", "/qa", "/bookings", "/packages", "/properties", "/partners",
          "/staff", "/support","/join-us","/partners"
        ];
      }
  },*/


  getMonthIndex (month) {
    let mon = {
      'January': 0,
      'February': 1,
      'March': 2,
      'April': 3,
      'May': 4,
      'June': 5,
      'July': 6,
      'August': 7,
      'September': 8,
      'October': 9,
      'November': 10,
      'December': 11
    }

    return mon[month];
  },

  getBudgetRange: function (instance, currencyId) {
		if(instance === 'min') {
			let min = 0;
			switch (currencyId) {
			case 1: min = 100;
				break;
			case 2: min = 15;
				break;
			default:
				min = 10;
				break;
			}
			return min;
		}
		if(instance === 'max') {
			let max = 0;
			switch (currencyId) {
			case 1: max = 100000;
				break;
			case 2: max = 15000;
				break;
			default:
				max = 10000;
				break;
			}
			return max;
		}
	},

  getNewInquiryStatus() {
    return 23; //new migration changes 
  },

  getPackageSentStatus() {
    return 26; //new migration changes 
  },

  getFollowUpInquiryStatus() {
    return 24; 
  },

  getAccessbilityDetails(key=''){
    // store.state.auth.role_id = store.state.dashRoleId
    let userAccessbility = [];
    userAccessbility.dashRoleIdState = store.state.dashRoleId;
    userAccessbility.getAuthUserRoleId = store.state.auth.role_id;
    userAccessbility.getAuthUserId = store.state.auth.id;
    userAccessbility.partnerIdState = store.state.partnerId;
    if(key !=''){
      if(key == 'partnerId'){
        return userAccessbility.partnerIdState['partnerId'];
      } else if (key == 'partnerSlug'){
        return userAccessbility.partnerIdState['partnerSlug'];
      } else if (key == 'partnerUserId'){
        return userAccessbility.partnerIdState['partnerUserId'];
      } else if(userAccessbility[key] != undefined){
        return userAccessbility[key];
      }
      return ;
    }
    return userAccessbility;
  },

  getReadableDate: function (date) {
		return moment(date).format('DD MMMM YYYY')
	},

  getReadableDateFormat: function (date) {
		return moment(date).format('DD-MM-YYYY')
	},
  partnerAllowedBookingStatus(){
    return [35,37,39,40];
  },

  async compressImage(base64) {
    let self = this;
    return await new Promise((resolve, reject) => {
        var img = new Image();
        img.src = base64;
        img.onload = function() {
          let definedWidth = 400;
          let imageWidth = img.width;
          let imageHeight = img.height;
          let scaleFactor = definedWidth / imageWidth;
          let elem = document.createElement('canvas');

          if(imageWidth > definedWidth){
            elem.width = definedWidth;
            elem.height = scaleFactor * imageHeight;
          }else{
            elem.width = imageWidth;
            elem.height = imageHeight
          }
          let data = base64;
          let ctx = elem.getContext('2d');
          // img.width and img.height will contain the original dimensions
          ctx.drawImage(img, 0, 0, elem.width, elem.height);
          let imageSizeInKb = (base64.length + 814)  / (1.37 *1024);
          console.log("original Size helper :: ", imageSizeInKb);
          if(imageSizeInKb > 700){
            //data = ctx.canvas.toDataURL('image/webp', 0.72);
            data = ctx.canvas
                      .toDataURL(navigator.userAgent.indexOf("Firefox") != -1 ? 'image/jpeg' : 'image/webp', 0.20)
                      .replace('image/jpeg','image/webp');
          } else  if(imageSizeInKb > 60){
            //data = ctx.canvas.toDataURL('image/webp', 0.72);
            data = ctx.canvas
                      .toDataURL(navigator.userAgent.indexOf("Firefox") != -1 ? 'image/jpeg' : 'image/webp', 0.60)
                      .replace('image/jpeg','image/webp');
          }else {
            //data = ctx.canvas.toDataURL('image/webp', 1.0);
            data = ctx.canvas
                      .toDataURL(navigator.userAgent.indexOf("Firefox") != -1 ? 'image/jpeg' : 'image/webp', 0.72)
                      .replace('image/jpeg','image/webp');
          }
          console.log("compress size :: helper ", (data.length + 814)  / (1.37 *1024))
          return resolve(data);
        };
    })
  },

  getProspecDefaultMsg(){
    let abc =
   `
Hello ***,

Greetings from Trexova.com ! We hope, you are doing amazing !

Through this email, we wish to propose a business partnership with your company for higher business growth for both the parties.

Let us inform, who we are …!

Trexova is one of the biggest Wellness Activities & Holidays marketplace of Asia. We offer 4800+ packages globally with 2000+ instructors and have had 10,000+ customers base. We offer SaaS solution to our partners where they can define their company/Institute/school, packages and rates as well.

Would like to inform that Trexova is a marketplace, we advertise and promote our partner's property and their packages on our platform. Trexova ensures that its partners' property and their packages reach potential travelers all over the world.

You may also check our official website https://www.trexova.com/1/tour-packages.

Happy to add that our business is growing day-to-day. We have been leading Indian market since 3.5 years. Now, we have started our business to others countries as well. In regards to international market, already we have 10k+ visitors averagely on daily basis. The majority of the visitors is from UK.

Currently, we are eagerly looking for some Portugal partners/properties as we are receiving huge queries for it from our customer end. Please inform if we can discuss about this further on call/email.

<b>Please note that we do not charge anything if you wish to join us.</b>

Waiting for your response !

Best Regards,

Priyanka Sangwan
Business Development Manager
Trexova UK Ltd
Mob: + 91 9599122268 (WhatsApp)
Email: partner.support@trexova.com
`;
    return abc;
  },
  getProspecDefaultSubject(){
    let subject = `Greetings from Trexova.com - The fastest Growing online marketplace for Wellness Packages and Yoga Rereats`;
    return subject;
  },

  packageIdCheck(id,index,type){
    let pkgStep = [
      'package','settings','experience','variants','reference','terms','media','price'
    ]
    if(id=="" || id == undefined){
      return true;
    }

    if(pkgStep.indexOf(type) == index){
      return true
    }
    return false;
    
  },
  async getBase64FromUrl(url) {
  // const getBase64FromUrl = async (url) => {
    let  data;
    let flag = false;
    //try{
      data = await fetch(url,{
        //mode: 'no-cors',
      }).catch(function(error) {
        flag = true;
        console.log(error,'test');
        //return;
    });
    if(flag){
      console.log('test','test')
      return new Promise((resolve,reject) => {
        reject('');
      });
      return ;
    }
    // }catch(e){
    //   //throw new Error("Not 2xx response");
    //   return ;
    // }
    
    if(data && data.status !=200){
        throw new Error("Not 2xx response", {cause: data});
    }
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob); 
      reader.onloadend = () => {
        const base64data = reader.result;   
        resolve(base64data);
      }
    });
  },

  getSuggestionTypeName(typeId,keyValue=false){
    let ar = {
      "19":"Inclusion",
      "20":"Exlusion",
      "21":"Benefits",
      "22":"Experience",
      "23":"Activities",
      "24":"Meal Type",
      "25":"Cuisines",
      // "26":"Inclusion",
    }
    if(keyValue){
      let ar1 = ar;
      Object.keys(ar1).forEach(function(key) {
        var newkey = key + "xxx";
          let vl = ar1[key];
          ar1[vl] = key;
        delete ar1[key];
      });
      return ar1[typeId];
    }
    
    // console.log(typeId,'av',ar.typeId)
    return ar[typeId];
  }



}



// WEBPACK FOOTER //
// ./src/services/helper.js